import { render, staticRenderFns } from "./expert-folder.vue?vue&type=template&id=d0c48936&"
import script from "./expert-folder.vue?vue&type=script&lang=ts&"
export * from "./expert-folder.vue?vue&type=script&lang=ts&"
import style0 from "./expert-folder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports